import React from 'react';
import Link from '@marvelapp/marvel-ui/link';

export default function HelpCopy() {
  return (
    <span className="display-inlineBlock" style={{ maxWidth: 480 }}>
      Something we haven't covered?{' '}
      <Link type="blue" url="mailto:help@marvelapp.com" target="_blank">
        Email us
      </Link>{' '}
      and we'll get back to you!
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/HelpCopy/index.js